import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';
const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  chip: {
    marginRight: theme.spacing.unit,
  },
  section1: {
    margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
  },
  section2: {
    margin: theme.spacing.unit * 2,
  },
  section3: {
    margin: `${theme.spacing.unit * 6}px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
    maxWidth:'50px',
  },
});

class  SelectionForm extends React.Component  {
  state={}

  constructor(props)
  {
    super(props);
    //bindings
    this.handleChangeReportingPeriod = this.handleChangeReportingPeriod.bind(this);
    this.handleChangeControlAccount = this.handleChangeControlAccount.bind(this);
  }

  componentDidMount()
  {
    //Consultar los reporting periods
    this.props.actions.fetchReportingPeriods(this.props.project)
    .then(res=>{
      if(res.data.rps && res.data.rps.length>0)
      {
        let rps = res.data.rps.map(rp=>{
          let w = {};
          w.rp = w.value =rp.reporting_number;
          w.name = w.label= rp.reporting_number;
          return w;
        });

        let all= {};
        all.rp = all.value= -1;//significa todos!
        all.name=all.label = "All";
        rps.unshift(all);

        this.setState({
          reporting_periods:rps, 
          reporting_period:-1, //todos
        });

        // this.props.changeForm(-1, -1);//todos
      }
    });
    
    this.props.actions.fetchControlAccounts(this.props.project)
    .then(res=>{

      if(res.data.control_accounts && res.data.control_accounts.length>0)
      {
        let control_accounts = res.data.control_accounts.map(ca=>{
          let w = {};
          w.control_account = w.value =ca.control_account;
          w.name = w.label= ca.name;
          return w;
        });

        let all= {};
        all.control_account = all.value= -1;//significa todos!
        all.name=all.label = "All";
        control_accounts.unshift(all);

        this.setState({
          control_accounts:control_accounts, 
          control_account:-1, //todos
        });

        // this.props.changeForm(-1, -1);//todos
      }
    });
  }

  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }


  handleChangeReportingPeriod(val)
  {
    this.setState({reporting_period:val});
    this.props.changeForm(val.value,this.state.control_account.control_account);
  }

  handleChangeControlAccount(val)
  {
    this.setState({control_account:val});
    this.props.changeForm( this.state.reporting_period.rp, val.value);
  }


  render()
  {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <div className={classes.section1}>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography gutterBottom variant="h6">
                Information
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={24}>
            <Grid item sm={3}>
              <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Reporting Period</InputLabel>
                <Select
                  required
                  id="reporting_period"
                  name="reporting_period"
                  value={this.getValueCatalog(this.state.reporting_periods,this.state.reporting_period)}
                  onChange={this.handleChangeReportingPeriod}
                  options={this.state.reporting_periods}
                >
                </Select>
            </Grid>
             <Grid item sm={3}>
              <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Control Account</InputLabel>
                <Select
                  required
                  id="control_account"
                  name="control_account"
                  value={this.getValueCatalog(this.state.control_accounts,this.state.control_account)}
                  onChange={this.handleChangeControlAccount}
                  options={this.state.control_accounts}
                >
                </Select>
            </Grid>
          </Grid>
        </div>
      </Paper>
    );
  }
}

SelectionForm.propTypes = {
  classes: PropTypes.object.isRequired,
};
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    status: state.status,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SelectionForm));



// WEBPACK FOOTER //
// ./src/features/status/SelectionForm.js